(() => {
  const ACTIVATE_AT = 0.65;

  const init = () => {
    document.querySelectorAll('[data-pdp-re-timeline]:not([data-pdp-re-timeline-ready])').forEach((section) => {
      section.setAttribute('data-pdp-re-timeline-ready', 'true');

      const items = Array.from(section.querySelectorAll('[data-timeline-item]'));
      const line = section.querySelector('.PDP-re-timeline__line');
      if (!items.length || !line) return;

      let ticking = false;

      const update = () => {
        ticking = false;
        const trigger = (window.innerHeight || document.documentElement.clientHeight) * ACTIVATE_AT;
        const lineRect = line.getBoundingClientRect();
        let lastNodeOffset = 0;

        items.forEach((item, index) => {
          const node = item.querySelector('.PDP-re-timeline__node');
          const rect = (node || item).getBoundingClientRect();
          const center = rect.top + rect.height / 2;

          item.classList.toggle('is-active', index === 0 || center < trigger);

          const offset = center - lineRect.top;
          if (offset > lastNodeOffset) lastNodeOffset = offset;
        });

        const head = Math.min(Math.max(trigger - lineRect.top, 0), lastNodeOffset);
        const pct = lineRect.height > 0 ? (head / lineRect.height) * 100 : 0;
        line.style.setProperty('--pdp-re-progress', `${Math.min(Math.max(pct, 0), 100)}%`);
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      window.addEventListener('load', requestUpdate);
      setTimeout(requestUpdate, 300);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();